import React, { Fragment } from "react";
import moment from "moment";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const Fitralist = (props) => {
  const {
    donationList,
    pageSize,
    pageNumber,
    setPageSize,
    setPageNumber,
    totalRecord,
  } = props;
  const theme = useTheme();

  const columns = [
    {
      flex: 0.3,
      minWidth: 80,
      field: "index",
      headerName: "Index",
    },
    {
      flex: 1,
      minWidth: 120,
      field: "name",
      headerName: "name",
    },
    {
      flex: 1,
      minWidth: 170,
      field: "p_id",
      headerName: "payment id",
    },
    {
      flex: 1,
      maxWidth: 80,
      field: "amount",
      headerName: "Amount",
      renderCell: ({ row }) => {
        const amt = parseFloat(row.amount).toFixed(2);
        return (
          <Typography sx={{ fontSize: "0.92rem !important" }}>
            ${amt}
          </Typography>
        );
      },
    },
    {
      flex: 1,
      maxWidth: 210,
      field: "created_at",
      headerName: "Date",
      renderCell: ({ row }) => {
        const fmt = "MMM DD, YYYY hh:mm A";
        const m = moment(row.created_at).format(fmt);
        return (
          <Typography sx={{ fontSize: "0.92rem !important" }}>{m}</Typography>
        );
      },
    },
    {
      flex: 2,
      maxWidth: 140,
      field: "status",
      headerName: "status",
      renderCell: (params) => {
        const status = params.row.status;

        const check = status === 0 ? false : true;
        return (
          <Box>
            <Button
              type="reset"
              variant="contained"
              size="small"
              style={{
                backgroundColor: check
                  ? theme.palette.primary.light
                  : theme.palette.text.disabled,
              }}
            >
              {status}
            </Button>
          </Box>
        );
      },
    },
    {
      flex: 1,
      minWidth: 90,
      field: "payment_type",
      headerName: "Payment Type",
      renderCell: (params) => {
        const p_type = params.row.payment_type;
        const check = p_type === "4" ? "Syed" : "Non-Syed";

        return (
          <Typography sx={{ fontSize: "0.92rem !important" }}>
            {check}
          </Typography>
        );
      },
    },
    {
      flex: 1,
      minWidth: 90,
      field: "wallet",
      headerName: "Type",
      renderCell: (params) => {
        const p_type = params.row.wallet;
        let check;
        if (p_type === null) {
          check = "Card";
        } else if (p_type === "apple_pay") {
          check = "Apple Pay";
        } else {
          check = "Google Pay";
        }

        return (
          <>
            <Typography sx={{ fontSize: "0.92rem !important" }}>
              {check}
            </Typography>
          </>
        );
      },
    },
  ];

  const assemList = donationList.map((data, index) => {
    return {
      index: index + pageSize * pageNumber + 1,
      id: data.id,
      name: data.first_name,
      p_id: data.p_id,
      amount: data.amount,
      created_at: data.created_at,
      status: data.status,
      payment_type: data.payment_type,
      wallet: data.wallet,
    };
  });

  return (
    <Fragment>
      <Card sx={{ width: "100%", overflowInline: "hidden" }}>
        <DataGrid
          hideFooterSelectedRowCount
          autoHeight
          localeText={{ noRowsLabel: "No results found" }}
          rowCount={Number(totalRecord)}
          page={pageNumber}
          columns={columns}
          rows={assemList}
          pageSize={pageSize}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={(newPageNumber) => setPageNumber(newPageNumber)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          sx={{
            ".MuiTablePagination-displayedRows": {
              marginTop: "1rem",
            },
            ".MuiTablePagination-selectLabel": {
              marginTop: "1.1rem",
            },
            ".MuiInputBase-root": {
              marginTop: "0.2rem",
            },
          }}
          pagination
          paginationMode="server"
        />
      </Card>
    </Fragment>
  );
};

export default Fitralist;
